import { Box, Divider, Typography } from '@mui/material';
import { useDrawer } from 'services/drawer/hooks';
import { UpdateCandidateStatus } from '../UpdateCandidateStatus';
import { useFlag } from 'services/flags/hooks';
import { Flags } from 'services/flags/constants';

type Props = {
  candidateIds: string[];
  atsJobId: string | null | undefined;
  onClearSelectedCandidates?: () => void;
};

export const CandidateStatusDrawer: React.FC<Props> = ({
  candidateIds,
  atsJobId,
  onClearSelectedCandidates
}) => {
  const defaultLockStatus = useFlag(Flags.DEFAULT_LOCK_UPDATE_STATUS);
  const { closeDrawer } = useDrawer();

  return (
    <Box height="100%" minWidth={300}>
      <Typography fontWeight="400">Candidate Status</Typography>
      <Typography variant="body2">
        {candidateIds.length} candidate(s) selected
      </Typography>

      <Divider sx={{ my: 2 }} />

      <UpdateCandidateStatus
        defaultLockStatus={defaultLockStatus ?? false}
        onCancel={closeDrawer}
        candidateIds={candidateIds}
        atsJobId={atsJobId}
        onClearSelectedCandidates={() => {
          closeDrawer();
          onClearSelectedCandidates?.();
        }}
      />
    </Box>
  );
};
